import { createFileRoute } from "@tanstack/react-router";

import { CareNavigationRebuiltDashboard } from "../tools/dashboards/CareNavigationRebuiltDashboard";

function CareNavigationRoute() {
  return <CareNavigationRebuiltDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/care-navigation")({
  component: CareNavigationRoute,
});
